import { Action } from '@ngrx/store';
import { ParametersListView } from '../../../_generated';

export enum ParametersAction {
  Load = '[Parameters] Load',
  Get = '[Parameters] Get',
  Reset = '[Parameters] Reset',
  Sync = '[Parameters] Sync',
}

export class Load implements Action {
  readonly type = ParametersAction.Load;
}

export class Get implements Action {
  readonly type = ParametersAction.Get;

  constructor(public payload: ParametersListView[]) {}
}

export class Reset implements Action {
  readonly type = ParametersAction.Reset;
}

export class Sync implements Action {
  readonly type = ParametersAction.Sync;

  constructor(public payload: number[]) {}
}

export type ParametersActionType = Load | Get | Reset | Sync;
